import React, { useEffect, useState } from 'react';
import {
    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices,
    Create, SimpleForm, TextInput, DateInput,
    ImageInput, ImageField, ReferenceInput, SelectInput,
    BooleanInput, NumberInput
} from 'react-admin';
import { useStyles } from "../../formStyles";
import RichTextInput from 'ra-input-rich-text';
import { parse } from "query-string";
import { CreateToolbar } from "../../CreateToolbar";
import CircularProgress from '@material-ui/core/CircularProgress';
import * as apiClient from "../../apiClient";
export const QuestionCreate = props => {
    const classes = useStyles({});
    const [isLoadingTest, setIsLoadingTest] = useState(true);
    const [testDetails, setTestDetails] = useState({});

    const { test_id: test_id_string } = parse(props.location.search);
    const test_id = test_id_string ? parseInt(test_id_string, 10) : "";


    const GetTestDetail = () => {
        setIsLoadingTest(true)
        apiClient.getData(`/tests/${test_id}`).then((response) => {
            setIsLoadingTest(false);
            setTestDetails(response[0])
        });
    }
    useEffect(() => {
        GetTestDetail();
    }, [test_id]);
    
    const redirect = test_id ? `/${testDetails?.testTypeId === 2 ? "gen-tests" : "tests"}/${test_id}/1` : "show";

    return (
        <>
            {isLoadingTest && <CircularProgress />}
            {!isLoadingTest && <Create {...props} title="Add new question">
                <SimpleForm variant="outlined" toolbar={<CreateToolbar {...props} />}
                    defaultValue={{ testId: test_id }}
                    redirect={redirect}
                >
                    <ReferenceInput label="Test" disabled source="testId" reference="tests" validate={required()} fullWidth={true} formClassName={classes.first_inline_input} >
                        <SelectInput optionText="name" />
                    </ReferenceInput>
                    <ReferenceInput label="Subject" source="subjectId" validate={required()} reference="subjects" fullWidth={true} formClassName={classes.last_inline_input}
                        sort={{ field: 'name', order: 'ASC' }}
                        perPage={5000}
                    >
                        <SelectInput optionText="name" />
                    </ReferenceInput>
                    <ReferenceInput label="Question Type" source="questionTypeId" validate={required()} reference="questiontypes" fullWidth={true} formClassName={classes.one_three_input}>
                        <SelectInput optionText="questionTypeName" />
                    </ReferenceInput>
                    <NumberInput source="noOfChoice" label="No of Choices" validate={required()} fullWidth={true} formClassName={classes.two_three_input} />
                    <NumberInput source="questionNumber" label="Question Number" validate={required()} fullWidth={true} formClassName={classes.last_three_input} />
                    <ReferenceInput label="Section Type" fullWidth
                        perPage={5000} source="sectionTypeId"
                        reference="statuses"
                        filter={{ statusType: 'Sections' }}
                        sort={{ field: 'status', order: 'ASC' }}
                        validate={required()} formClassName={classes.one_three_input}
                    >
                        <SelectInput optionText="status" variant="outlined" fullWidth validate={[required()]} />
                    </ReferenceInput>
                    <ReferenceInput label="Scoring Type" fullWidth
                        perPage={5000} source="scoringTypeId"
                        reference="scoring-types" 
                        sort={{ field: 'name', order: 'ASC' }}
                        validate={required()} formClassName={classes.two_three_input}
                    >
                        <SelectInput optionText="name" variant="outlined" fullWidth validate={[required()]} />
                    </ReferenceInput>
                    <RichTextInput source="instructions" label="Instructions" />
                    <ImageInput source="instructionUrl" label="Instruction" accept="image/*" className="logourl">
                        <ImageField source="instructionUrl" title="Icon" />
                    </ImageInput>
                    <NumberInput source="totalMarks" label="Total Marks" validate={required()} fullWidth={true} formClassName={classes.one_three_input} />
                    <NumberInput source="totalTime" label="Total Time" validate={required()} fullWidth={true} formClassName={classes.two_three_input} />
                    <RichTextInput source="question" label="Question" />
                    <ImageInput source="logoUrl" label="Icon" accept="image/*" className="logourl">
                        <ImageField source="logoUrl" title="Icon" />
                    </ImageInput>
                    <BooleanInput initialValue={true} source="mustAnswer" validate={required()} label="Must Answer" />
                </SimpleForm>
            </Create>}
        </>

    );
}